module.exports = __webpack_public_path__ + "img/flag-english.aa749660.jpg";